import { render, staticRenderFns } from "./PcPage.vue?vue&type=template&id=5ab09d16&scoped=true"
import script from "./PcPage.vue?vue&type=script&lang=ts"
export * from "./PcPage.vue?vue&type=script&lang=ts"
import style0 from "./PcPage.vue?vue&type=style&index=0&id=5ab09d16&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ab09d16",
  null
  
)

export default component.exports